// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React from 'react';
import styles from './image.module.less';
import cn from 'classnames';
import {Editor} from '../../../../../shared/editor/editor';
import {img_url} from '../../../ui/img_url';
import {use_screen} from '../../../lib/screen_util';

interface i_image {
    img: string;
    img_mobile?: string;
    gradient?: boolean;
}

interface i_image_editor_props {
    value: i_image;
    on_change: (new_value: i_image)=>void;
}

export const Image = (props: i_image)=>{
    const {width} = use_screen();
    const img_src = width >= 768 ? props.img : props.img_mobile || props.img;
    return <div className={cn(styles.image_wrapper,
      props.gradient && styles.gradient)}>
      <img src={img_url(img_src)} alt="image" /></div>;
};

export const Image_editor = (props: i_image_editor_props)=>{
  const {value = {img: '', gradient: false}, on_change} = props;
  type editor_key = keyof i_image;
  type editor_type = 'text' | 'textarea' | 'number' | 'boolean' | 'selector';
  const editors = [
      ['img', 'Image path', 'text'],
      ['img_mobile', 'Image path', 'text'],
      ['gradient', 'With gradient', 'boolean'],
  ].map(([key, label, type])=>({key: key as editor_key, label,
      type: type as editor_type}));
  return <Editor
    value={value}
    editors={editors}
    on_change={on_change}
    title="Cta"
  />;
};
